import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Music2, Youtube, Mail, BookOpen } from "lucide-react";

const Footer = () => (
    <footer
        data-testid="site-footer"
        className="mt-32 border-t border-hl-border bg-hl-tinted/40 hl-grain"
    >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-12">
            <div className="md:col-span-5">
                <div className="flex items-center gap-2 mb-4">
                    <BookOpen className="w-4 h-4 text-hl-secondary" strokeWidth={1.5} />
                    <span className="font-serif text-3xl text-hl-brown">
                        Icook<span className="italic text-hl-secondary">Greek</span>
                    </span>
                </div>
                <p className="text-hl-muted max-w-md leading-relaxed">
                    A digital cookbook and cultural archive — preserving the flavors,
                    stories, and traditions of Greek and Cypriot cuisine, one
                    grandmother's recipe at a time.
                </p>
                <p className="font-script text-3xl text-hl-secondary mt-6">
                    καλή όρεξη
                </p>
            </div>

            <div className="md:col-span-3">
                <h4 className="text-[11px] uppercase tracking-[0.25em] text-hl-muted mb-4">Wander</h4>
                <div className="flex flex-col gap-2.5 text-hl-text font-serif text-lg">
                    <Link to="/" className="hl-link w-fit">Home</Link>
                    <Link to="/recipes" className="hl-link w-fit">Recipes</Link>
                    <Link to="/stories" className="hl-link w-fit">Taste the Story</Link>
                    <Link to="/aphrodites-roots" className="hl-link w-fit">Aphrodite's Roots</Link>
                    <Link to="/our-story" className="hl-link w-fit">Our Story</Link>
                    <Link to="/about" className="hl-link w-fit">About</Link>
                    <Link to="/admin/login" data-testid="footer-admin-login" className="hl-link w-fit text-hl-muted/80 text-sm font-sans">Admin</Link>
                </div>
            </div>

            <div className="md:col-span-4">
                <h4 className="text-[11px] uppercase tracking-[0.25em] text-hl-muted mb-4">Follow the kitchen</h4>
                <div className="flex items-center gap-3 mb-5">
                    <a
                        href="https://tiktok.com/@icookgreek"
                        target="_blank" rel="noreferrer"
                        data-testid="social-tiktok"
                        className="w-11 h-11 rounded-full flex items-center justify-center bg-hl-brown text-hl-bg hover:bg-hl-secondary hl-btn-lift"
                        aria-label="TikTok"
                    >
                        <Music2 className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                    <a
                        href="https://www.instagram.com/icookmike/?hl=en"
                        target="_blank" rel="noreferrer"
                        data-testid="social-instagram"
                        className="w-11 h-11 rounded-full flex items-center justify-center bg-hl-primary text-hl-bg hover:bg-hl-primaryDeep hl-btn-lift"
                        aria-label="Instagram"
                    >
                        <Instagram className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                    <a
                        href="https://www.youtube.com/@Icookmike"
                        target="_blank" rel="noreferrer"
                        data-testid="social-youtube"
                        className="w-11 h-11 rounded-full flex items-center justify-center bg-hl-secondary text-hl-bg hover:bg-hl-secondaryDeep hl-btn-lift"
                        aria-label="YouTube"
                    >
                        <Youtube className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                    <a
                        href="mailto:greekicook@gmail.com"
                        data-testid="social-email"
                        className="w-11 h-11 rounded-full flex items-center justify-center bg-hl-tinted text-hl-brown border border-hl-border hover:bg-hl-bg hl-btn-lift"
                        aria-label="Email"
                    >
                        <Mail className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                </div>
                <p className="text-hl-muted text-sm leading-relaxed">
                    Send a recipe from your grandmother — we'd love to cook it.
                    <br />
                    <a href="mailto:greekicook@gmail.com" className="hl-link text-hl-secondary">
                        greekicook@gmail.com
                    </a>
                </p>
            </div>
        </div>
        <div className="border-t border-hl-border/70 text-center py-6 text-[11px] text-hl-muted tracking-[0.25em] uppercase">
            © {new Date().getFullYear()} IcookGreek · Recipes our grandparents would recognize
        </div>
    </footer>
);

export default Footer;
